import { API_URL } from "../util/apiPaths";
import { request } from "./api.js";

export function addEventType( params ) {
  return request( "POST", API_URL.ADMIN_EVENT_TYPES, params );
}

export function getAdminEventTypes( params ) {
  const retVal = request( "GET", API_URL.ADMIN_EVENT_TYPES, params );

  return retVal;
}

export function updateAdminEventType( params ) {
  return request( "PUT", API_URL.ADMIN_EVENT_TYPES, params );
}

export function getAdminEventTypeDetail( params ) {
  return request( "GET", `${ API_URL.ADMIN_EVENT_TYPES }/${ params }` );
}

export function enableDisableEventTypeRequest( params ) {
  return request( "PUT", API_URL.ENABLE_DISABLE_EVENT_TYPE_ADMIN, params );
}
